export const enWebDevelopment = {
  // Hero Section
  title: "Professional Web Development Services",
  description: "Custom-built websites and web applications designed for performance, scalability, and exceptional user experiences.",
  subtitle: "Web Development Solutions",

  // Services Section
  servicesTitle: "Our Development Expertise",
  servicesSubtitle: "Comprehensive solutions tailored to your business needs",
  services: {
    frontend: {
      title: "Frontend Development",
      description: "Interactive user interfaces built with modern frameworks for seamless experiences.",
      technologies: ["React", "Vue.js", "Angular", "TypeScript", "Tailwind CSS"]
    },
    backend: {
      title: "Backend Development",
      description: "Robust server-side architecture and API development for your applications.",
      technologies: ["Node.js", "Python", "PHP", "Ruby on Rails", "Java"]
    },
    database: {
      title: "Database Solutions",
      description: "Optimized data storage and retrieval systems for your specific requirements.",
      technologies: ["PostgreSQL", "MySQL", "MongoDB", "Firebase", "Redis"]
    },
    devops: {
      title: "DevOps & Deployment",
      description: "Automated deployment pipelines and cloud infrastructure management.",
      technologies: ["Docker", "AWS", "Azure", "CI/CD", "Kubernetes"]
    },
    ecommerce: {
      title: "E-Commerce Solutions",
      description: "Custom online stores with secure payment processing and inventory management.",
      technologies: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal"]
    },
    cms: {
      title: "Content Management",
      description: "User-friendly CMS platforms for easy content updates and management.",
      technologies: ["WordPress", "Strapi", "Contentful", "Sanity", "Drupal"]
    }
  },

  // Process Section
  processTitle: "Our Development Process",
  processSteps: [
    {
      title: "Discovery & Planning",
      description: "We analyze your requirements and create a detailed project roadmap."
    },
    {
      title: "UI/UX Design",
      description: "Creating intuitive user interfaces and seamless user experiences."
    },
    {
      title: "Development",
      description: "Agile implementation with regular progress updates and feedback."
    },
    {
      title: "Quality Assurance",
      description: "Rigorous testing across devices, browsers, and performance metrics."
    },
    {
      title: "Deployment",
      description: "Seamless launch with optimized hosting configuration."
    },
    {
      title: "Maintenance",
      description: "Ongoing support, updates, and performance monitoring."
    }
  ]
};

export const frWebDevelopment = {
  title: "Services de Développement Web Professionnels",
  description: "Sites web et applications web sur mesure conçus pour la performance, l'évolutivité et des expériences utilisateur exceptionnelles.",
  subtitle: "Solutions de Développement Web",

  servicesTitle: "Notre Expertise en Développement",
  servicesSubtitle: "Solutions complètes adaptées aux besoins de votre entreprise",
  services: {
    frontend: {
      title: "Développement Frontend",
      description: "Interfaces utilisateur interactives construites avec des frameworks modernes pour des expériences fluides.",
      technologies: ["React", "Vue.js", "Angular", "TypeScript", "Tailwind CSS"]
    },
    backend: {
      title: "Développement Backend",
      description: "Architecture serveur robuste et développement d'API pour vos applications.",
      technologies: ["Node.js", "Python", "PHP", "Ruby on Rails", "Java"]
    },
    database: {
      title: "Solutions de Base de Données",
      description: "Systèmes de stockage et de récupération de données optimisés pour vos besoins spécifiques.",
      technologies: ["PostgreSQL", "MySQL", "MongoDB", "Firebase", "Redis"]
    },
    devops: {
      title: "DevOps & Déploiement",
      description: "Pipelines de déploiement automatisés et gestion de l'infrastructure cloud.",
      technologies: ["Docker", "AWS", "Azure", "CI/CD", "Kubernetes"]
    },
    ecommerce: {
      title: "Solutions E-Commerce",
      description: "Magasins en ligne personnalisés avec traitement des paiements sécurisé et gestion des stocks.",
      technologies: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal"]
    },
    cms: {
      title: "Gestion de Contenu",
      description: "Plateformes CMS conviviales pour des mises à jour et une gestion de contenu faciles.",
      technologies: ["WordPress", "Strapi", "Contentful", "Sanity", "Drupal"]
    }
  },

  processTitle: "Notre Processus de Développement",
  processSteps: [
    {
      title: "Découverte & Planification",
      description: "Nous analysons vos besoins et créons une feuille de route de projet détaillée."
    },
    {
      title: "Conception UI/UX",
      description: "Création d'interfaces utilisateur intuitives et d'expériences utilisateur fluides."
    },
    {
      title: "Développement",
      description: "Mise en œuvre agile avec des mises à jour régulières et des retours d'expérience."
    },
    {
      title: "Assurance Qualité",
      description: "Tests rigoureux sur différents appareils, navigateurs et métriques de performance."
    },
    {
      title: "Déploiement",
      description: "Lancement sans faille avec une configuration d'hébergement optimisée."
    },
    {
      title: "Maintenance",
      description: "Support continu, mises à jour et surveillance des performances."
    }
  ]
};

export const nlWebDevelopment = {
  title: "Professionele Webontwikkelingsdiensten",
  description: "Op maat gemaakte websites en webapplicaties ontworpen voor prestaties, schaalbaarheid en uitzonderlijke gebruikerservaringen.",
  subtitle: "Webontwikkelingsoplossingen",

  servicesTitle: "Onze Ontwikkelingsexpertise",
  servicesSubtitle: "Uitgebreide oplossingen afgestemd op uw zakelijke behoeften",
  services: {
    frontend: {
      title: "Frontend Ontwikkeling",
      description: "Interactieve gebruikersinterfaces gebouwd met moderne frameworks voor naadloze ervaringen.",
      technologies: ["React", "Vue.js", "Angular", "TypeScript", "Tailwind CSS"]
    },
    backend: {
      title: "Backend Ontwikkeling",
      description: "Robuuste server-side architectuur en API-ontwikkeling voor uw applicaties.",
      technologies: ["Node.js", "Python", "PHP", "Ruby on Rails", "Java"]
    },
    database: {
      title: "Databaseoplossingen",
      description: "Geoptimaliseerde opslag- en ophaalsystemen voor uw specifieke vereisten.",
      technologies: ["PostgreSQL", "MySQL", "MongoDB", "Firebase", "Redis"]
    },
    devops: {
      title: "DevOps & Implementatie",
      description: "Geautomatiseerde implementatiepijplijnen en cloudinfrastructuurbeheer.",
      technologies: ["Docker", "AWS", "Azure", "CI/CD", "Kubernetes"]
    },
    ecommerce: {
      title: "E-Commerce Oplossingen",
      description: "Aangepaste online winkels met veilige betalingsverwerking en voorraadbeheer.",
      technologies: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal"]
    },
    cms: {
      title: "Contentbeheer",
      description: "Gebruiksvriendelijke CMS-platforms voor eenvoudige contentupdates en beheer.",
      technologies: ["WordPress", "Strapi", "Contentful", "Sanity", "Drupal"]
    }
  },

  processTitle: "Ons Ontwikkelingsproces",
  processSteps: [
    {
      title: "Ontdekking & Planning",
      description: "We analyseren uw vereisten en maken een gedetailleerde projectroutekaart."
    },
    {
      title: "UI/UX Ontwerp",
      description: "Het creëren van intuïtieve gebruikersinterfaces en naadloze gebruikerservaringen."
    },
    {
      title: "Ontwikkeling",
      description: "Agile implementatie met regelmatige voortgangsupdates en feedback."
    },
    {
      title: "Kwaliteitsborging",
      description: "Grondige tests op apparaten, browsers en prestatiecriteria."
    },
    {
      title: "Implementatie",
      description: "Naadloze lancering met geoptimaliseerde hostingconfiguratie."
    },
    {
      title: "Onderhoud",
      description: "Doorlopende ondersteuning, updates en prestatiemonitoring."
    }
  ]
};

export const deWebDevelopment = {
  title: "Professionelle Webentwicklungsdienste",
  description: "Maßgeschneiderte Websites und Webanwendungen, entwickelt für Leistung, Skalierbarkeit und außergewöhnliche Benutzererfahrungen.",
  subtitle: "Webentwicklungslösungen",

  servicesTitle: "Unsere Entwicklungsexpertise",
  servicesSubtitle: "Umfassende Lösungen, zugeschnitten auf Ihre Geschäftsanforderungen",
  services: {
    frontend: {
      title: "Frontend-Entwicklung",
      description: "Interaktive Benutzeroberflächen mit modernen Frameworks für nahtlose Erlebnisse.",
      technologies: ["React", "Vue.js", "Angular", "TypeScript", "Tailwind CSS"]
    },
    backend: {
      title: "Backend-Entwicklung",
      description: "Robuste serverseitige Architektur und API-Entwicklung für Ihre Anwendungen.",
      technologies: ["Node.js", "Python", "PHP", "Ruby on Rails", "Java"]
    },
    database: {
      title: "Datenbanklösungen",
      description: "Optimierte Speicher- und Abrufsysteme für Ihre spezifischen Anforderungen.",
      technologies: ["PostgreSQL", "MySQL", "MongoDB", "Firebase", "Redis"]
    },
    devops: {
      title: "DevOps & Bereitstellung",
      description: "Automatisierte Bereitstellungspipelines und Cloud-Infrastrukturmanagement.",
      technologies: ["Docker", "AWS", "Azure", "CI/CD", "Kubernetes"]
    },
    ecommerce: {
      title: "E-Commerce-Lösungen",
      description: "Individuelle Online-Shops mit sicherer Zahlungsabwicklung und Bestandsverwaltung.",
      technologies: ["Shopify", "WooCommerce", "Magento", "Stripe", "PayPal"]
    },
    cms: {
      title: "Content-Management",
      description: "Benutzerfreundliche CMS-Plattformen für einfache Inhaltsaktualisierungen und Verwaltung.",
      technologies: ["WordPress", "Strapi", "Contentful", "Sanity", "Drupal"]
    }
  },

  processTitle: "Unser Entwicklungsprozess",
  processSteps: [
    {
      title: "Entdeckung & Planung",
      description: "Wir analysieren Ihre Anforderungen und erstellen eine detaillierte Projekt-Roadmap."
    },
    {
      title: "UI/UX Design",
      description: "Intuitive Benutzeroberflächen und nahtlose Benutzererfahrungen gestalten."
    },
    {
      title: "Entwicklung",
      description: "Agile Umsetzung mit regelmäßigen Fortschrittsberichten und Feedback."
    },
    {
      title: "Qualitätssicherung",
      description: "Gründliche Tests auf Geräten, Browsern und Leistungsmetriken."
    },
    {
      title: "Bereitstellung",
      description: "Nahtloser Launch mit optimierter Hosting-Konfiguration."
    },
    {
      title: "Wartung",
      description: "Laufende Unterstützung, Updates und Leistungsüberwachung."
    }
  ]
};
